/* eslint-disable max-len */
import { interopTestSuffix } from 'config/urlHelper';
import { getUrlWithoutLoginDetails } from '../../common/url';

export const productionConfig = {
  API: {
    ROOT_URL: () => 'https://api.op.econsult.health',
    IE_ROOT_URL: practiceId => `https://${practiceId}${interopTestSuffix()}.op.econsult.health/cors-es`,
    SUBMISSION_URL: practiceId => `https://${practiceId}${interopTestSuffix()}.op.econsult.health/api/consultation/submitsession`,
    POSTCODE_URL: (practiceId, postcode) => `https://${practiceId}${interopTestSuffix()}.op.econsult.health/findMatchingPostcodes/${postcode}`,
    ADDRESSES_URL: (practiceId, postcode) => `https://${practiceId}${interopTestSuffix()}.op.econsult.health/searchPostcode/${postcode}`,
  },
  S3_BUCKET: `https://s3.eu-west-2.amazonaws.com/prod.frontend.econsult.health/ecspecialist-frontend/${process.env.REACT_APP_VERSION}/build`,
  SESSION_TIMEOUT: {
    IN_MINUTES: 30,
  },
  DEV_LOGIN_ENABLED: false,
  FEDERATED_LOGIN_PROVIDER: {
    NHS_LOGIN_LIVE: {
      DISPLAY_NAME: 'NHS login',
      REDIRECT_URL: `https://auth.login.nhs.uk/authorize?scope=openid%20profile%20email%20profile_extended%20phone%20gp_registration_details&client_id=eConsult&redirect_uri=${encodeURI('https://assets.op.econsult.health/')}&response_type=code&vtr=%5B%22P9.Cp.Cd%22%2C%20%22P9.Cp.Ck%22%2C%20%22P9.Cm%22%5D&state=${getUrlWithoutLoginDetails(window.location)}`,
    },
  },
};
